import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import { useSelector } from "react-redux";
import YhButton from "../../../../../ui/YhButton";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
import { useStepper } from "../../exportLead/StepperContext";
import { ImageUpLoad } from "../EmployeeDocuments/EmployeeDocumentServices";
import {
  isTruthy,
  openErrorNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import SourceSubSourceFields, {
  SourceType,
} from "../../../../../Shared/SourceSubSourceFields";
import { selectActiveOrganizationId } from "../../../../../redux/authSlice";

const OfficialInformation = (props: any) => {
  const { updateStepperProps } = useStepper();
  const activeOrgId = useSelector(selectActiveOrganizationId);
  const organizationId =
    activeOrgId && activeOrgId !== "all" && activeOrgId !== "*"
      ? String(activeOrgId)
      : "";
  const [apiResponse, setApiResponse] = useState(false);
  const [file, setFile] = useState<any>(null);
  const [headers, setHeaders] = useState<string[]>([]);
  const [fileData, setFileData] = useState<any[]>([]);
  const [sourceType, setSourceType] = useState<SourceType>("bulk");
  const [subSource, setSubSource] = useState("");

  const handleFileChange = (event: any) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;
    setFile(selectedFile);

    Papa.parse(selectedFile, {
      header: true,
      complete: (result: any) => {
        const csvHeaders = result.meta.fields || [];
        const csvData = result.data || [];
        setFileData(
          csvData.filter((item: any) => Object.keys(item)?.length > 2)
        );
        setHeaders(csvHeaders);
      },
      error: (error: any) => {
        openErrorNotification(error?.message || "CSV parsing failed");
      },
    });
  };

  const submitForm = async () => {
    if (!file) {
      openErrorNotification("Please upload a CSV file");
      return;
    }
    if (!subSource.trim()) {
      openErrorNotification("Select or create a sub-source");
      return;
    }

    const data = new FormData();
    data.append("file", file);

    try {
      setApiResponse(true);
      const uploadedUrl = await ImageUpLoad(data);
      const withSource = (fileData || []).map((row: any) => ({
        ...row,
        lead_source: subSource.trim(),
      }));
      updateStepperProps({
        headers,
        imagePath: uploadedUrl,
        fileData: withSource,
        sourceType,
        subSource: subSource.trim(),
      });
      props.nextStep?.();
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    } finally {
      setApiResponse(false);
    }
  };

  useEffect(() => {
    props.registerStepActions?.({ submit: submitForm });
  });

  return (
    <div className="flex flex-col gap-5">
      <div>
        <h2 className="text-lg font-semibold text-[#111827]">Upload File</h2>
        <p className="mt-1 text-sm text-[#6B7280]">
          Browse and upload the CSV file for this import.
        </p>
      </div>

      <SourceSubSourceFields
        organizationId={organizationId}
        sourceType={sourceType}
        subSource={subSource}
        onSourceTypeChange={setSourceType}
        onSubSourceChange={setSubSource}
      />

      {file ? (
        <div className="flex max-w-xl items-center justify-between gap-3 rounded-xl bg-[#F5F5F5] px-4 py-3">
          <span className="truncate text-sm text-[#333]">{file.name}</span>
          <button
            type="button"
            className="shrink-0 text-sm font-semibold text-[#DC2626] hover:underline"
            onClick={() => {
              setHeaders([]);
              setFile(null);
              setFileData([]);
            }}
          >
            Remove
          </button>
        </div>
      ) : null}

      <div className="max-w-xl">
        <p className="yh-label mb-1">CSV File</p>
        <input
          accept=".csv"
          id="bulk-upload-csv"
          type="file"
          onChange={handleFileChange}
          className="block w-full text-sm text-[#374151] file:mr-3 file:rounded-lg file:border-0 file:bg-[#EEF0FF] file:px-3 file:py-2 file:text-sm file:font-semibold file:text-[#4338CA]"
        />
      </div>

      {!props.hideFooterButtons && (
        <div className="mt-2 flex justify-end gap-2">
          <YhButton variant="secondary" size="sm" onClick={props.backStep}>
            Back
          </YhButton>
          <YhButton variant="primary" size="sm" onClick={submitForm}>
            Save & Continue
          </YhButton>
        </div>
      )}

      {apiResponse && <CustomLoader apiResponse={apiResponse} />}
    </div>
  );
};

export default OfficialInformation;
